import React, { useEffect } from "react"
import { makeStyles } from "@material-ui/core/styles"
import ImageGallery from "react-image-gallery"
import { useSwipeable } from "react-swipeable"

// material-ui components
import { List, ListItem, Typography } from "@material-ui/core"

import ThumbSwipeHelpers from "src/assets/js/ThumbSwipeHelpers.js"

import styles from "src/assets/jss/material-kit-react/views/ListingsView/sections/propertyDetailStyles.js"

const useStyles = makeStyles(styles)

const PropertyDetail = ({
  property,
  globalState,
  listingType,
  isRenovation = false,
}) => {
  const classes = useStyles()
  let galleryRef = null
  let cachedWindowWidth = null

  const thumbnailSwipeHandlers = useSwipeable({
    onSwiped: () => {}, // After any swipe   (SwipeEventData) => void
    onSwipedLeft: function(data) {
      ThumbSwipeHelpers.handleSlideMove(data)
    }, // After LEFT swipe  (SwipeEventData) => void
    onSwipedRight: function(data) {
      ThumbSwipeHelpers.handleSlideMove(data)
    }, // After RIGHT swipe (SwipeEventData) => void
    onSwipedUp: () => {}, // After UP swipe    (SwipeEventData) => void
    onSwipedDown: () => {}, // After DOWN swipe  (SwipeEventData) => void
    onSwiping: () => {}, // During swiping    (SwipeEventData) => void
    onTap: () => {}, // After a tap       ({ event }) => void
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  })

  useEffect(() => {
    if (!globalState.isBrowser) return
    cachedWindowWidth = window.outerWidth

    ThumbSwipeHelpers.setGalleryRef(galleryRef)
    ThumbSwipeHelpers.setThumbs("image-gallery-thumbnail")
    ThumbSwipeHelpers.setThumbSliderRef("image-gallery-thumbnails-container")
    ThumbSwipeHelpers.setSizes()
    ThumbSwipeHelpers.setSwipeableHandlers(thumbnailSwipeHandlers)

    const rect = document
      .getElementsByClassName("image-gallery")[0]
      .getBoundingClientRect()
    window.scrollTo({
      top: rect.top + window.scrollY,
      behavior: "smooth",
    })

    galleryRef.play()

    function handleResize(e) {
      if (window.outerWidth === cachedWindowWidth) return
      ThumbSwipeHelpers.setSizes()
      cachedWindowWidth = window.outerWidth
    }
    window.addEventListener("resize", handleResize)

    return _ => {
      window.removeEventListener("resize", handleResize)
    }
  })

  const testimonial =
    listingType === "renovation"
      ? property.refTestimonial_remodel
      : property.refTestimonial

  const photos =
    listingType === "renovation" &&
    property.media_remodelPhotos &&
    property.media_remodelPhotos.length
      ? property.media_remodelPhotos
      : property.media_photos

  const images = photos.map(p => {
    return { original: p.file.url, thumbnail: p.file.url }
  })

  return (
    <div className={classes.propertyDetailRoot}>
      <ImageGallery
        ref={i => (galleryRef = i)}
        items={images}
        showPlayButton={false}
        autoPlay={true}
        slideInterval={listingType === "renovation" ? 4000 : 2000}
      />
      <div className="propertyDetailInfo-root">
        <Typography variant="h4" className="MuiTypography-gutterBottomSmall">
          <span className="propertyDetailInfo_streetAddress">
            {property.text_streetAddress}
          </span>
          <span className="propertyDetailInfo_city">
            &nbsp;|&nbsp;{property.text_city}
          </span>
        </Typography>
        <Typography variant="h4" gutterBottom>
          {(property.text_status == "Available"
            ? "Offered at $"
            : "Sold at $") + property.text_price}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {property.text_description.text_description}
        </Typography>
        {testimonial && (
          <Typography variant="body1" className={"quote-root"}>
            <Typography component="span" className={"quote-text"}>
              "{testimonial.text_testimonial.text_testimonial}"
            </Typography>
            <Typography component="span" className={"quote-author"}>
              -&nbsp;{testimonial.text_clientPublicName}
            </Typography>
          </Typography>
        )}
        <List>
          <ListItem>
            <span className="label">Bedrooms:</span>
            <span>{property.text_bedrooms}</span>
          </ListItem>
          <ListItem>
            <span className="label">Bathrooms:</span>
            <span>{property.text_bathrooms}</span>
          </ListItem>
          {property.text_squareFeet && (
            <ListItem>
              <span className="label">Square Feet:</span>
              <span>{property.text_squareFeet}</span>
            </ListItem>
          )}
          {property.text_lotSize && (
            <ListItem>
              <span className="label">Lot Size:</span>
              <span>{property.text_lotSize}</span>
            </ListItem>
          )}
          {property.text_yearBuilt && (
            <ListItem>
              <span className="label">Year Built:</span>
              <span>{property.text_yearBuilt}</span>
            </ListItem>
          )}
          <ListItem>
            <span className="label">Role:</span>
            <span>
              {property.boolean_agentRole ? "Selling Agent" : "Buying Agent"}
            </span>
          </ListItem>
        </List>
      </div>
    </div>
  )
}

export default PropertyDetail
